"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

var _react = _interopRequireWildcard(require("react"));

var _icons = require("@ant-design/icons");

var _form = _interopRequireDefault(require("antd/lib/form"));

var _FeedbackItem = _interopRequireDefault(require("./FeedbackItem"));

require("../activity.scss");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Item
} = _form.default;
const itemStyle = {
  width: '100%',
  marginBottom: '10px',
  marginTop: '10px'
};

class OptionFeedbackItem extends _react.Component {
  constructor() {
    super(...arguments);

    this.onAddClick = e => {
      const {
        addFeedback
      } = this.props;
      addFeedback();
    };
  }

  render() {
    const {
      type,
      disabled,
      feedback,
      updateFeedback,
      removeFeedback,
      option
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "feedback-item"
    }, feedback ? /*#__PURE__*/_react.default.createElement("ul", {
      className: "feedback-list-item-container"
    }, /*#__PURE__*/_react.default.createElement(_FeedbackItem.default, {
      type: type,
      disabled: disabled,
      feedback: feedback,
      options: [option],
      updateFeedback: updateFeedback
    }), !disabled && /*#__PURE__*/_react.default.createElement("button", {
      className: "dashed-danger-button",
      onClick: removeFeedback
    }, /*#__PURE__*/_react.default.createElement(_icons.MinusOutlined, null), ' ', "Remove Option Feedback")) : /*#__PURE__*/_react.default.createElement(Item, {
      style: itemStyle
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      disabled: disabled,
      type: "dashed",
      onClick: this.onAddClick,
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/_react.default.createElement(_icons.PlusOutlined, null), ' ', "Add feedback")));
  }

}

var _default = OptionFeedbackItem;
exports.default = _default;